// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"58":"private","328":"admin"}[chunkId] || chunkId) + "." + {"58":"86bb866d","328":"5d4b7382","468":"f7158d9f","514":"71618d93","722":"fa32e86c","864":"b9e5bbad","968":"338bbcf7"}[chunkId] + ".chunk.js";
};